import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private shownSubj$ = new BehaviorSubject(false);
  private count = 0;

  get shown$() {
    return this.shownSubj$.asObservable();
  }

  constructor() {}

  public show() {
    if (this.count === 0) {
      this.shownSubj$.next(true);
    }
    this.count++;
  }

  public hide() {
    this.count--;
    if (this.count === 0) {
      this.shownSubj$.next(false);
    }
    if (this.count < 0) {
      this.count = 0;
    }
  }
}
